import React from 'react';
import { NavLink, Link } from 'react-router-dom';

//Bootstrap
import { Col } from 'react-bootstrap';

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophoneAlt, faVideo, faNewspaper } from '@fortawesome/free-solid-svg-icons';

// import './ProductRelatedItem.css';

const ProductRelatedItem = (props) => {
    const article = parseInt(props.TIENE_ARTICULO) === 1 ? <FontAwesomeIcon icon={faNewspaper} className="mr-2 custom-icon-title" title="Artículo" /> : null;
    const video = parseInt(props.TIENE_VIDEO) === 1 ? <FontAwesomeIcon icon={faVideo} className="mr-2 custom-icon-title" title="Video" /> : null;
    const audio = parseInt(props.TIENE_AUDIO) === 1 ? <FontAwesomeIcon icon={faMicrophoneAlt} className="mr-2 custom-icon-title" title="Audio" /> : null;
    return (
        <Col sm="6" md="4" className="py-3">
            <div className="overflow-hidden">
                <div className="custom-img-scale">
                    <Link to={{ pathname: `/trabajos/${props.URL_POST}`, state: { id: props.ID } }}>
                        <img src={`../assets/images/${props.IMAGEN_PRINCIPAL}`} alt={decodeURIComponent(props.TITULO)} style={{width: '100%'}} className="img-fluid" />
                    </Link>
                </div>
            </div>
            <h5 className="mt-2 mb-3">
                <NavLink to={{ pathname: `/trabajos/${props.URL_POST}` }} className="custom-title-link custom-text-black custom-font-weight-bolder">{decodeURIComponent(props.TITULO)}</NavLink>
            </h5>
            <p>
                <span className="badge custom-badge-blue py-1 px-2 text-uppercase custom-max-content custom-float-start">{decodeURIComponent(props.TIPO)}</span>
                <span className="custom-float-end">
                    {article ? <FontAwesomeIcon icon={faNewspaper} className="mr-2 custom-icon-title" title="Artículo" />
                        : null}
                    {video ? <FontAwesomeIcon icon={faVideo} className="mr-2 custom-icon-title" title="Video" />
                        : null}
                    {audio ? <FontAwesomeIcon icon={faMicrophoneAlt} className="mr-2 custom-icon-title" title="Audio" />
                        : null}
                </span>
                <br />
            </p>
            <hr className="custom-hr-100"/>
        </Col>
    );
};

export default ProductRelatedItem;